module.exports = __webpack_public_path__ + "img/nitka.b08fa45f.png";